import { InfoDialog } from '@strata/react-dialog';
import { DisplayRichText } from '@strata/react-rich-text-area';
import PropTypes from 'prop-types';

export const CopayAssistanceMessageDialog = ({
    isOpen = false,
    copayAssistanceMessage = undefined,
    onSecondaryButtonClick,
}) => (
    <InfoDialog
        dialogTitle={copayAssistanceMessage?.title}
        isOpen={isOpen}
        onClose={onSecondaryButtonClick}
        dialogContent={
            copayAssistanceMessage?.longMessage ? (
                <DisplayRichText value={copayAssistanceMessage?.longMessage} />
            ) : (
                copayAssistanceMessage?.shortMessage
            )
        }
    />
);

CopayAssistanceMessageDialog.propTypes = {
    isOpen: PropTypes.bool,
    copayAssistanceMessage: PropTypes.shape({
        title: PropTypes.string,
        shortMessage: PropTypes.string,
        longMessage: PropTypes.string,
    }),
    onSecondaryButtonClick: PropTypes.func.isRequired,
};
